import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
    return (
        <div className="Perks p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Benefits of Working with a Reputable Cross-Platform App Development Company</h2>
                        <p>TekRevol excels in cross-platform app development, providing innovative solutions, efficient processes, and industry-specific proficiency to guarantee your app not only stands out but also excels across various platforms.</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Modern <br/>Solutions</h4>
                                <p>Explore the forefront of technology with innovative approaches, crafting bespoke cross-platform solutions to elevate your online presence.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Transparency <br/>Project</h4>
                                <p>Utilize dedicated project management tools for a clear view of ongoing processes, fostering communication and informed decision-making.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Scalability and Adaptability</h4>
                                <p>TekRevol empowers your app with scalable solutions, guaranteeing smooth adaptation to changing needs and business expansion.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Ongoing <br/>Support</h4>
                                <p>Guaranteeing a smooth and error-free app experience for users and quick issue resolution when needed.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Perks